// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error--message{display:flex;justify-content:center;font-size:2em}", "",{"version":3,"sources":["webpack://./app/components/error/style.css"],"names":[],"mappings":"AAAA,gBACI,YAAA,CACA,sBAAA,CACA,aAAA","sourcesContent":[".error--message {\n    display: flex;\n    justify-content: center;\n    font-size: 2em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
